
import React from "react";
import type { ManagerScheduledOrder,OrderDetailsModalProps } from "../interface/ScheduledOrder ";
import {
  formatDateTime,
  formatScheduleDate,
  formatScheduleTime,
} from "../utils/scheduledOrders";


const OrderDetailsModal: React.FC<OrderDetailsModalProps> = ({
  order,
  onClose,
}) => (
  <div
    className="modal fade show d-block manager-order-modal"
    style={{ backgroundColor: "rgba(15, 23, 42, 0.55)" }}
    onClick={onClose}
  >
    <div
      className="modal-dialog modal-dialog-centered admin-order-modal-dialog"
      style={{ maxWidth: "980px" }}
      onClick={(event) => event.stopPropagation()}
    >
      <div
        className="modal-content custom-modal-padding15px"
        style={{ minHeight: "580px" }}
      >
        <div className="modal-header manager-modal-header d-flex justify-content-between align-items-center">
          <h5 className="modal-title mb-0">
            Order Details: {order.orderId}
          </h5>
          <button
            type="button"
            className="custom-close-btn3"
            aria-label="Close"
            onClick={onClose}
          >
            <i className="bi bi-x customcross" />
          </button>
        </div>

        <div className="modal-body p-0">
          <div className="row g-0 p-3">
            <div className="col-md-6 pe-md-4 border-end">
              <ul className="list-unstyled order-status-list delivery-type-section">
                <li className="time-event-section-delivery-type mt-1">
                  <strong>Payment Status</strong>
                  <span>{order.paymentStatus || "--"}</span>
                </li>
                <li className="time-event-section-delivery-type mt-1">
                  <strong>Schedule Date</strong>
                  <span>{formatScheduleDate(order.scheduleDate)}</span>
                </li>
                <li className="time-event-section-delivery-type mt-1">
                  <strong>Schedule Time</strong>
                  <span>
                    {formatScheduleTime(order.scheduleTime)}
                    {order.scheduleEndTime
                      ? ` – ${formatScheduleTime(order.scheduleEndTime)}`
                      : ""}
                  </span>
                </li>
                <li className="time-event-section-delivery-type mt-1">
                  <strong>Order Type</strong>
                  <span>{order.type || "--"}</span>
                </li>
              </ul>

              <div className="accordion mt-3">
                <div className="accordion-item border rounded p-2 mt-3">
                  <h2 className="accordion-header">
                    <div className="accordion-button">
                      <strong>Clinic Details</strong>
                    </div>
                  </h2>
                  <div className="accordion-body">
                    <div className="doctor-name-bottom">
                      {order.clinic || "--"}
                    </div>
                    <div className="doctor-name-bottom">
                      {order.clinicMobileNo || "--"}
                    </div>
                    <div className="doctor-name-bottom">
                      {order.clinicAddress || "--"}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 ps-md-4">
              <h6 className="border-bottom pb-2">Order Timeline</h6>

              <div className="mb-3">
                <strong>{formatDateTime(order.createdTime)}</strong>
                <div>Order Created</div>
                <small className="text-muted">Created</small>
              </div>

              <div className="mb-3">
                <strong>{formatDateTime(order.createdTime)}</strong>
                <div>Payment Details</div>
                <div className="small text-muted mt-1">
                  <div>Original Amount: ₹{order.originalAmount}</div>
                  <div>Discount Amount: ₹{order.discountAmount}</div>
                  <div>Coupon: {order.couponPercentage}% Off</div>
                  <strong>Paid Amount: ₹{order.paidAmount}</strong>
                </div>
                <small className="text-muted">
                  {order.paymentStatus || "Pending"}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default OrderDetailsModal;
